import React from 'react';
import PropTypes from 'prop-types';

import { List, ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Subheader from 'material-ui/Subheader';
import ActionAssignment from 'material-ui/svg-icons/action/assignment';
import ActionDeleteForever from 'material-ui/svg-icons/action/delete-forever';
import FileUploadField from 'ntnu-react/material/FileUploadField';
import shallowEqual from 'ntnu-react/util/shallowEqual';

class AttachmentTab extends React.Component {
    static propTypes = {
        attachments: PropTypes.array.isRequired,
        onUploadFiles: PropTypes.func,
        onDeleteFile: PropTypes.func,
        onClickFile: PropTypes.func,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        attachments: [],
        disabled: false,
        onUploadFiles: () => undefined,
        onDeleteFile: () => undefined,
        onClickFile: () => undefined,
    };

    shouldComponentUpdate(nextProps) {
        return !shallowEqual(this.props.attachments, nextProps.attachments);
    }

    handleUpload = (files) => {
        this.props.onUploadFiles(files);
    }

    handleDelete = (file) => {
        return (e) => {
            e.stopPropagation();
            this.props.onDeleteFile(file);
            return false;
        };
    }

    handleClick = (file) => {
        return () => {
            this.props.onClickFile(file);
        };
    }

    render() {
        const { attachments, disabled } = this.props;
        return (
            <section>
                <p style={{marginTop: '1rem'}}>
                    Her kan du laste opp filer som vedlegg til forslaget.
                    Det er ikke mulig å overskrive filer som er lastet opp.
                    Slett først gamle og last deretter opp nye hvis filer skal
                    oppdateres.
                </p>

                <List>
                    <Subheader inset={true}>Vedlegg</Subheader>
                    {attachments && attachments.map((file) => (
                        <ListItem
                            key={`file-${file}`}
                            primaryText={file}
                            leftAvatar={<Avatar icon={<ActionAssignment />} />}
                            rightIcon={<ActionDeleteForever onClick={this.handleDelete(file)} />}
                            onClick={this.handleClick(file)}
                        />
                    ))}
                </List>

                <FileUploadField
                    label="Last opp vedlegg"
                    disabled={disabled}
                    multiple={true}
                    onFile={this.handleUpload}
                />
            </section>
        );
    }
}

export default AttachmentTab;



// WEBPACK FOOTER //
// ./src/components/AttachmentTab.js